// extracted by mini-css-extract-plugin
export default {"contact-info":"ContactInfo_contact-info__WTgmp","info-item":"ContactInfo_info-item__NVqTy","info-holder":"ContactInfo_info-holder__DlPM7"};